// extracted by mini-css-extract-plugin
export default {"melodyVideo":"rJ-z","isFullWidth":"sJ-z","landingPageVideo":"tJ-z","play":"uJ-z","iframeVideo":"vJ-z","playHidden":"wJ-z","fullwidth":"xJ-z"};